import { AccessType } from "../../common/enums/DRCXEnums";
import { IAccessPermission } from "../../common/models/AccessPermission";

export enum ObjectTagValuesTypeEnum {
    Device = 0,
    Tank = 1,
    TankBattery = 2,
    Well = 3
}

export enum ObjectTagValuesGridColumnTypeEnum {
    Name = 0,
    Value = 1,
    Units = 2,
    Timestamp = 3,
    UID = 4,
    ReadItem = 5,
    WriteItem = 6,
    LookupList = 7,
    Formula = 8
};

export type ObjectTagValuesConfigurationDescription = {
    id: number;
    name: string;
    viewType: ObjectTagValuesTypeEnum;
    access: AccessType;
    users: Array<ObjectTagValuesUserModel>;
    userPermissions: Array<IAccessPermission>;
    internal: boolean;
    createdByUserName?: string;
}

export type ObjectTagValuesConfiguration = {
    tagGroups: Array<ObjectTagValuesTagGroupConfiguration>;
    gridColumns: Array<ObjectTagValuesGridColumnConfiguration>;
} & ObjectTagValuesConfigurationDescription;

export type ObjectTagValuesTagGroupConfiguration = {
    name: string;
    tags: Array<ObjectTagValuesTagGroupTagConfiguration>;
}

export type ObjectTagValuesTagGroupTagConfiguration = {
    tatID?: number;
    tatName?: string;
    tatTypeID?: number;
    tatTypeName?: string;
}

export type ObjectTagValuesGridColumnConfiguration = {
    name: string;
    type: ObjectTagValuesGridColumnTypeEnum;
}

export type ObjectTagValuesDefault = {
    configurationID: number;
    forCurrentUser: boolean;
    forUsersWithoutDefault: boolean;
    forAllUsers: boolean;
    forAllObjectsInCurrentGroupWithoutDefault: boolean;
}

export type ObjectTagValuesDefaultOptions = {
    groupName: string;
    objectName?: string;
    isForCurrentUser: boolean;
    isForUsersWithoutDefault: boolean;
    isForAllUsers: boolean;
    isForAllObjectsInCurrentGroupWithoutDefault: boolean;
}

export type ObjectTagValuesUserModel = {
    id: number;
    firstName: string;
    lastName: string;
};

export type ObjectTagValuesConfigurations = {
    defaultConfigurationID: number | undefined;
    // These are the permissions granted to the current user for the current
    // group for the ObjectTagValuesConfiguration access functionality type.
    userPermissions: Array<IAccessPermission>;
    configurations: Array<ObjectTagValuesConfigurationDescription>;
}

export type ObjectTagValuesAvailableItem = {
    equatableKey: string;
    tagName?: string;
    tagUomName?: string;
    tatID?: number;
    tatName?: string;
    tatTypeID?: number;
    tatTypeName?: string;
    eLynxGroupName?: string;
}